/// <reference path='../_all.ts' />

module part {
  'use strict';


  export class ProductRelation {
    constructor(
      public ProductName: string,
      public ProductId: number,
      public NavReferenzBenutzergruppe: number,
      public NavReferenzSeriennummerErforderlich: number,
      public UrlD: string,
      public UrlE: string
    ) { }
  }



}